// extracted by mini-css-extract-plugin
module.exports = {"outerWrapper":"ErrorBoundary_outerWrapper__2BLif","innerWrapper":"ErrorBoundary_innerWrapper__3pwcX","Link":"ErrorBoundary_Link__C7bSC"};